const handleClickShowTopMenuDropdown = () => {
    document.getElementById("top-menu-dropdown").classList.toggle("show");
}

export {
    handleClickShowTopMenuDropdown
}
